import template from './PopupNewsletter.vhtml';
import get from "lodash/get";

export default {
    name: 'PopupNewsletter',
    template: template,
    props: {
        newsletterPopupFields: {
            type: String,
            default: '',
        }
    },
    data: () => ({
        newsletterChecked: false,
        acceptNewsletterTerms: false,
        showPopup: false,
        newsletterPopup: []
    }),
    watch: {},
    methods: {
        acceptTerms() {
            this.showPopup = false
        },
        declineNewsletter() {
            this.showPopup = false
            this.newsletterChecked = false
            this.acceptNewsletterTerms = false
        },
        newsletterToggle() {
            if (this.newsletterChecked) {
                this.showPopup = true;
            }
        }
    },
    created() {
        this.newsletterPopup = JSON.parse(this.newsletterPopupFields);
        console.log(this.newsletterPopup);
    },
};
